/*
 * Payzen Redirection Page From Auto Submit
 */
import * as $ from 'jquery'

$(document).ready(function () {
  const PAYZEN_FORM = $('#payzen-redirect-form')
  if (PAYZEN_FORM.length) {
    PAYZEN_FORM.submit()
  }
})



// WEBPACK FOOTER //
// ./skippair/static/js/payzen-auto-post.js